import React, { useState, useEffect } from "react";
import * as d3 from "d3";

const FitAnalysisBarChart = ({isActive, data, mxwidth}) => {
  // console.log("data Bar Chart", data)
  const maxValue = Math.max(...data.map(item => item.value));
  useEffect(() => {

    if (!isActive) return;
    const timeout = setTimeout(() => {
    const margin = { top: 20, right: 50, bottom: 30, left: 30 };
    const width = (mxwidth ? mxwidth : 600) - margin.left - margin.right;
    const height = 200 - margin.top - margin.bottom;

    const x = d3.scaleBand().range([0, width]).padding(0.6);
    const y = d3.scaleLinear().range([height, 0]);
    d3.select(".bar-chart svg").remove();

    const svg = d3
      .select(".bar-chart")
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // Set domains
    const maxRoundedValue = 20 * Math.ceil(d3.max(data, (d) => d.value) / 20);
    x.domain(data.map((d) => d.name));
    y.domain([0, maxValue]);
    

    // Create full background bars
    svg
      .selectAll(".full-bar")
      .data(data)
      .enter()
      .append("rect")
      .attr("class", "full-bar")
      .attr("x", (d) => x(d.name))
      .attr("width", x.bandwidth())
      .attr("y", (d) => y(maxValue))
    //   .attr("height", (d) => height - y(maxValue))
      .style("fill", "rgb(63 64 76 / 50%)");

    // Create data bars
    svg
      .selectAll(".bar")
      .data(data)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("x", (d) => x(d.name))
      .attr("width", x.bandwidth())
      .attr("y", (d) => y(d.value))
      .attr("height", (d) => height - y(d.value))
      .style("fill", "rgb(229 38 64 / 50%)");

    // Add value labels inside the bars
    // svg
    //   .selectAll(".label")
    //   .data(data)
    //   .enter()
    //   .append("text")
    //   .attr("class", "label")
    // //   .attr("x", (d) => x(d.name) + x.bandwidth() / 2)
    // //   .attr("y", (d) => (d.value < 10 ? y(d.value) - 10 : y(d.value) + 25)) 
    //   .attr("text-anchor", "middle")
    //   .style("fill", "white")
    //   .style("font-size", "16px")
    //   .style("font-weight", "500")
    //   .text((d) => d.value);

    // Add bottom axis
    svg
      .append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x).tickSizeOuter(0))
      .style("fill", "white")
      .style("font-size", "12px")
      .style("font-weight", "500")

      const yAxis = svg
      .append("g")
      .call(d3.axisLeft(y).ticks(5).tickSizeOuter(0)); 

    yAxis.selectAll(".tick").each(function (d) {
        svg
          .append("line")
          .attr("x1", 0)
          .attr("y1", y(d))
          .attr("x2", width)
          .attr("y2", y(d))
          .attr("stroke", "rgb(159 157 160 / 50%)")
          .attr("stroke-width", 0.5)
      });
    // Remove the y-axis
    d3.selectAll(".domain").remove();
    svg.selectAll(".tick line").remove();
    svg.selectAll(".tick text").style("fill", "white");
  }, 100);
  return () => clearTimeout(timeout);
  }, [isActive]);

  return (
    <div
      className="bar-chart"
      style={{
        width: "100%",
        margin: "0 auto",
      }}
    ></div>
  );
};

export default FitAnalysisBarChart;
